<template>
    <div class="contact">
        <label :class="[isMobile ? 'news-msg-mobile' : 'news-msg']">鲁澳經貿</label>


        <div :class="[isMobile ? 'trade-link-mobile' : 'trade-link']">
            <div v-for="(item, index) in newsList" :key="index" class="link-item" @click="toFriendUrl(item.url)">
                {{ item.name }}
            </div>
        </div>
    </div>
</template>
  
  
<script>

export default {
    name: 'Contact',
    data() {
        return {
            isMobile: false,
            newsList: [],
        }
    },
    props: {
        netConfig: {}
    },
    created() {
        this.isMobile = window.isMobile
    },
    mounted() {
        var that = this;
        this.$axios.get("index/inspect").then(function (response) {
            that.newsList = response.data.data
        });
    },
    methods: {
        toFriendUrl(url) {
            if (typeof url === 'undefined' || url == null || url === '') {
                return
            }
            window.open(url, "_blank");
        }
    },
}
</script>
  
  
<style lang="scss" rel="stylesheet/scss" scoped>
.contact {
    align-items: center;
    flex-direction: column;
    display: flex;
    box-sizing: border-box;



    .news-msg {
        width: 1040px;
        box-sizing: border-box;
        margin-top: 40px;
        font-size: 28px;
        color: #301E03
    }


    .news-msg-mobile {
        box-sizing: border-box;
        padding: 20px;
        width: 100%;
        font-size: 22px;
        color: #301E03
    }

    .trade-link {
        width: 1040px;
        margin-top: 40px;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        flex-wrap: wrap;

        .link-item {
            cursor: pointer;
            text-align: right;
            margin-bottom: 14px;
            width: 20%;
            font-size: 16px;
            color: #301E03;
        }

        .link-item:hover {
            color: #A05200;
        }
    }


    .trade-link-mobile {
        box-sizing: border-box;
        padding-left: 20px;
        width: 100%;
        margin-top: 10px;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        flex-wrap: wrap;

        .link-item {
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            -webkit-tap-highlight-color: transparent;
            outline: none;
            background: none;
            text-decoration: none;
            cursor: pointer;
            text-align: left;
            margin-bottom: 28px;
            width: 50%;
            font-size: 16px;
            color: #301E03;
        }

        .link-item:hover {
            color: #A05200;
        }
    }

}
</style>